import { render } from "./addSalary.vue?vue&type=template&id=7c3738e4"
import script from "./addSalary.vue?vue&type=script&lang=js"
export * from "./addSalary.vue?vue&type=script&lang=js"

import "./addSalary.vue?vue&type=style&index=0&id=7c3738e4&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__